import React, {useEffect, useState} from "react";
import axios from 'axios';
import styled from "styled-components";
import Footer from "../../components/Footer/Footer"
import MenuBar from "../../components/Header/MenuBar";
import ConnectTable from "../../components/Table/ConnectTable"
import Side from "../../components/Side/Side";
import GoogleAd from "../../components/GoogleAd/GoogleAd";
import Pagination from "react-js-pagination";
import "../../components/style/Pagination.css"
import {Helmet} from "react-helmet";

function KSIC_HS_Link(){
    // table 변수
    const [tableDataList , setTableDataList] = useState([]);
    const tableHeader = ["KSIC 코드", "설명", "HS 코드", "설명"];
    // search 변수
    const [searchTarget, setSearchTarget] = useState("");
    // pagination 변수
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [dataLength, setDataLength] = useState();
    // 코드 종류
    const [codeNumber, setCodeNumber] = useState();

    const ksicHsLink = () => {
        axios.post('/api/connect/ksicAndHs',{page:page, limit:limit, searchTarget:searchTarget})
            .then((response) => {
                console.log(response)
                setCodeNumber(response.data.whatIsThisCode)
                setDataLength(response.data.totalCount)
                const changeData = response.data.data.map( item => ({
                    codeA: item.ksic_code,
                    codeB: item.hs_code,
                    codeA_def_kr: item.ksic_def_kr,
                    codeB_def_kr: item.hs_def_kr
                }))
                setTableDataList(changeData)
            })
            .catch((error)=>{
                console.error("Error ksic - hs link list axios request", error)
            })

    }
    useEffect(()=>{
        ksicHsLink()
    },[page])

    const filterData = (e) => {
        setSearchTarget(e.target.value)
    }

    //pagination
    const handlePageChange = (page) => {
        setPage(page)
    }

    //keypress event
    const keyPress = (e) => {
        if(e.key === 'Enter'){
            setPage(1)
            ksicHsLink();
        }
    }
    return(
        <>
            <Helmet>
                <title>KSIC HS 연계표 검색</title>
                <meta name="description" content="KSIC코드(한국표준산업분류코드)와 HS코드(품목분류코드)를 검색하여 조회할 수 있으며 KSIC코드(한국표준산업분류코드)와 HS코드(품목분류코드)의 연계표를 확인할 수 있습니다."/>
                <meta name="robots" content="index, follow, max-snippet:-1" />
                <meta property="og:type" content="article" />
                <meta name="og:title" content="KSIC HS 연계표 검색" />
                <meta property="og:description" content="KSIC코드(한국표준산업분류코드)와 HS코드(품목분류코드)를 검색하여 조회할 수 있으며 KSIC코드(한국표준산업분류코드)와 HS코드(품목분류코드)의 연계표를 확인할 수 있습니다." />
                <meta name="og:site_name" content="search code" />
                <meta name="og:url" content="https://code.researchall.net/search_KSIC_HS_Link" />
            </Helmet>
            <MenuBar />
            <div style={{display:"flex", justifyContent:"center"}}>
                <Side />
                <Center>
                    <TitleField>
                        <Title>KSIC-HS 연계표 조회</Title>
                    </TitleField>
                    <Wrap>
                        <Box>
                            <GuideText>KSIC코드(한국표준산업분류코드)와 HS코드(품목분류코드) 혹은 키워드를 통해 원하시는 정보를 찾으실 수 있습니다.</GuideText>
                            <InlineField>
                                <SearchField onChange={filterData} onKeyPress={keyPress}/>
                                <Button onClick={ksicHsLink}>검색</Button>
                            </InlineField>
                        </Box>
                    </Wrap>
                    <ConnectTable tableData={tableDataList} tableHeader={tableHeader} codeNumber={codeNumber}/>
                    <Pagination
                        activePage={page}
                        itemsCountPerPage={limit}
                        totalItemsCount={dataLength}
                        pageRangeDisplayed={5}
                        prevPageText={"<"}
                        nextPageText={">"}
                        onChange={handlePageChange}
                    />
                    <GoogleAd slot="4662594652" />
                </Center>
                <Side/>
            </div>
            <Footer/>
        </>
    )
}

export default KSIC_HS_Link;

const Wrap = styled.div`
    margin-top: 20px;
    display: flex;
    background-color: #FFFFFF;
    justify-content: center;
    margin-bottom: 13px;
`;

const Box = styled.div`
    width: 100%;
    display: block;
    background-color: #eeeeee;
    height: 130px;
    padding: 10px;
    border-radius: 10px;

    div {
        p {
            margin-left: 10px;
            margin-top: 30px;
        }
    }
`;

const TitleField = styled.div`
    margin-top: 20px;
    margin-left: 10px;
`;

const Title = styled.h1`
    font-weight: 1000;
    font-size: 25px;
`;

const Button = styled.button`
    width: 120px;
    height: 40px;
    font-size: 15px;
    background-color: #4671E9;
    color: aliceblue;
    font-weight: bold;
    border: 0px;
    border-radius: 5px;
    margin: 15px;
    cursor: pointer;
    &:hover {
        background-color: #2e5bee;
        color: white;
    }
`;

const SearchField = styled.input`
    width: calc(100% - 40%);
    height: 15px;
    border: 1px solid #ddd;
    margin: 15px 10px 20px 10px;
    font-size: 15px;
    padding: 12px;
    border-radius: 5px;
`;

const InlineField = styled.div`
    display: flex;
`;

const GuideText = styled.p`
    margin: 20px 10px 10px 20px;
    font-size: 14px;
`;
const Center = styled.div`
    width: 50%;
    @media ${({theme}) => theme.device.tabletL} {
        width: 90%;
    }
`;
